module.exports = __webpack_public_path__ + "static/media/house-solid.1225d7e1.png";